import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-cards.css';
import { UitkCardTags, UitkCardContentSectionBorders, UitkCardContentSectionPaddings } from './types.esm.js';
var getClassNameList = classNames.bind(styles);
var UitkCardContentSection = function (props) {
  var border = props.border,
    children = props.children,
    className = props.className,
    padded = props.padded,
    tag = props.tag,
    attributes = __rest(props, ["border", "children", "className", "padded", "tag"]);
  var link;
  var newChildren = [];
  var Tag = tag && UitkCardTags.get(tag) || UitkCardTags.get('div');
  // Map through the children and place the ones we want in specific places
  React.Children.forEach(children, function (child) {
    if (!child) {
      return;
    }
    switch (child.type.displayName) {
      case 'UitkCardLink':
        link = child;
        break;
      default:
        newChildren.push(child);
    }
  });
  var paddedClass = function (prop, paddedBaseClass) {
    var propType = typeof prop;
    var classStr = [];
    if (propType === 'boolean') {
      classStr.push("".concat(paddedBaseClass, "-padded"));
    } else {
      prop && prop.forEach(function (value) {
        return classStr.push("".concat(paddedBaseClass, "-padded-").concat(UitkCardContentSectionPaddings.get(value)));
      });
    }
    return classStr.join(' ');
  };
  var baseClass = 'uitk-card-content-section';
  var cssClassNames = getClassNameList(baseClass, border && "".concat(baseClass, "-border-").concat(UitkCardContentSectionBorders.get(border)), link && "".concat(baseClass, "-has-link"), padded && paddedClass(padded, baseClass), className);
  return React.createElement(Tag, __assign({
    className: cssClassNames
  }, attributes), newChildren, link);
};
UitkCardContentSection.defaultProps = {
  padded: true
};
UitkCardContentSection.displayName = 'UitkCardContentSection';
// Temporary, unstable
var UitkCardAlohaContentSection = UitkCardContentSection;
export { UitkCardAlohaContentSection, UitkCardContentSection };